import { render, staticRenderFns } from "./AreaCompanyOrder.vue?vue&type=template&id=ce156776&scoped=true&"
import script from "./AreaCompanyOrder.vue?vue&type=script&lang=js&"
export * from "./AreaCompanyOrder.vue?vue&type=script&lang=js&"
import style0 from "./AreaCompanyOrder.vue?vue&type=style&index=0&id=ce156776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce156776",
  null
  
)

export default component.exports